import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Trans } from "../utils/i18n";

class Select extends React.Component {
    render() {
        const { disabled, field, input, meta: { touched, error } } = this.props;

        return (
            <FormControl
                error={touched && error}
                variant={"outlined"}
                size={field.size || undefined}
            >
                <InputLabel
                    size={field.size || undefined}
                    htmlFor={'select' + input.name}>
                    {field.required ? <>{field.label} *</> : field.label}
                </InputLabel>
                <MuiSelect
                    disabled={disabled}
                    name={input.name}
                    id={'select' + input.name }
                    native
                    label={field.required ? <>{field.label} *</> : field.label}
                    size={field.size || undefined}
                    style={field.style}
                    {...input}
                    onChange={(event) => {
                        input.onChange(event);
                        if (field.onChange) {
                            field.onChange(event);
                        }
                    }}
                >
                    {
                        !field.disableUnselected && <option aria-label={<Trans i18nKey="select.none">None</Trans>} value="" />
                    }
                    {
                        field.options
                        .map((item, index) => (
                            <option key={index} value={item.value}>{item.label}</option>
                        ))
                    }
                </MuiSelect>
                { touched && error && <FormHelperText>{ error }</FormHelperText> }
            </FormControl>
        );
    }
}

export default Select
